import React from "react";
import { ProductListViewHeader } from "./components/product-list-view-header";
import { ProductListViewItem } from "./components/product-list-view-item";
import { ListShimmerX3 } from "../shimmer/shimmer_types";
import { NoContentMessage } from "../no_content_message";
export function ProductListView(props) {
    const { products, isLoading } = props;
    return isLoading ? (React.createElement("div", { className: "flex flex-col gap-4 w-full" },
        React.createElement(ListShimmerX3, null),
        React.createElement(ListShimmerX3, null),
        React.createElement(ListShimmerX3, null))) : products.length > 0 ? (React.createElement("form", { className: "w-full flex gap-8" },
        React.createElement("div", { className: "grow grid grid-cols-12 gap-4" },
            React.createElement(ProductListViewHeader, null),
            products?.map((product, index) => (React.createElement(ProductListViewItem, { key: index, product: product })))))) : (React.createElement(NoContentMessage, { messages: ["No products found"] }));
}
